import { company } from '@/config/company'
import { services } from '@/config/content'
import styles from './Services.module.css'

export function Services() {
  return (
    <section className={styles.section} aria-labelledby="services-title">
      <div className="container">
        <p className={styles.legal}>{company.legalName}</p>
        <h2 id="services-title">Hizmetlerimiz</h2>
        <div className={styles.grid}>
          {services.map((item) => (
            <article key={item.title} className={styles.item}>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
